import { render, staticRenderFns } from "./EditKinesitherapie.vue?vue&type=template&id=5d9aba4e&scoped=true"
import script from "./EditKinesitherapie.vue?vue&type=script&lang=js"
export * from "./EditKinesitherapie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9aba4e",
  null
  
)

export default component.exports